export default __webpack_public_path__ + "static/media/close.ec5dc9a8.svg";